// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon-em6","clicked":"Icon_clicked-uEb"};